/* eslint-disable no-unused-vars */
import _ from 'lodash';
import React, { forwardRef, useState } from 'react';

import FormWrapperContainer from './form-wrapper-container';

const FormWrapperForm = ({ handleSubmit, onSubmitHandler, isCheckForm = false, ...props }, ref) => {
  const onKeyDown = (e) => e.key === 'Enter' && e.preventDefault();
  const [disabledCompleteBtn, setDisabledCompleteBtn] = useState(false);

  const onSubmit = (e) => {
    e.preventDefault();
    handleSubmit(async (data) => {
      setDisabledCompleteBtn(true);
      await onSubmitHandler({ data: data, status: 'Pending sync' });
      setDisabledCompleteBtn(false);
    })();
  };

  return !isCheckForm ? (
    <form id="formWrapper" onKeyDown={onKeyDown} onSubmit={onSubmit}>
      <FormWrapperContainer {...props} ref={ref} disabledCompleteBtn={disabledCompleteBtn} />
    </form>
  ) : (
    <FormWrapperContainer
      {...props}
      ref={ref}
      isCheckForm={isCheckForm}
      disabledCompleteBtn={disabledCompleteBtn}
    />
  );
};

export default React.memo(forwardRef(FormWrapperForm, _.isEqual));
